import {
  FETCH_ALL_PARTNERS,
  FETCH_ALL_PARTNERS_SUCCESS,
  FETCH_ALL_PARTNERS_FAILURE,

  FETCH_PARTNER_BY_ID_SUCCESS,
  FETCH_PARTNER_BY_ID_FAILURE,
  RESET_FETCH_PARTNER_BY_ID,


  FETCH_PARTNER_DASHBOARD_DETAILS_SUCCESS,
  
  CREATE_PARTNER,
  CREATE_PARTNER_SUCCESS,
  CREATE_PARTNER_FAILURE,
  
  ACTIVATE_PARTNER_SUCCESS,
  DEACTIVATE_PARTNER_SUCCESS,
  
  EDIT_PARTNER,
  EDIT_PARTNER_SUCCESS,
  EDIT_PARTNER_FAILURE,

  RESET_ACTION_DIALOG,

  EXPORT_PARTNER_SUCCESS,
  RESTORE_PARTNERS_INITIAL,
  MAKE_REQUEST_PARTNERS,
  FETCH_DIALOG_DATA,
  PRINT_PARTNERS_SUCCESS,
  SEARCH_TABLE,
} from "../ActionTypes";


const INIT_STATE = {
  allPartners: [],
  allPartnerFetchSuccess: false,

  singlePartnerDetail: {},
  tablePaginationData: {},
  partnersDashboardDetails: {},
  allPartnersDataForPrinting: [],

  fetchingDataGeneral: true, // firing fetchAllPartners
  makingRequest: false,
  fetchingPartnerDialogData: false,
  isLoading:true,

  

  dialogSaving: false,
  dialogSaveSuccess: false,
}


function reducers(state = INIT_STATE, action) {
  switch (action.type) {
    case FETCH_ALL_PARTNERS: return {
      ...state,
      fetchingDataGeneral: true,
      allPartnerFetchSuccess: false,
    }

    case FETCH_ALL_PARTNERS_SUCCESS: return {
      ...state,
      allPartners: action.payload.data,
      tablePaginationData: action.payload.meta,
      fetchingDataGeneral: false,
      makingRequest: false,
      allPartnerFetchSuccess: true
    }

    case FETCH_ALL_PARTNERS_FAILURE: return {
      ...state,
      fetchingDataGeneral: false,
      makingRequest: false,
      allPartnerFetchSuccess: false,
    }

    case FETCH_PARTNER_BY_ID_SUCCESS: return {
      ...state,
      singlePartnerDetail: action.payload,
      fetchingDataGeneral: false,
      makingRequest: false,
      fetchingPartnerDialogData: false,
    }

    case FETCH_PARTNER_BY_ID_FAILURE: return {
      ...state,
      fetchingPartnerDialogData: false,
      fetchingDataGeneral: false,
      makingRequest: false,
    }

    case RESET_FETCH_PARTNER_BY_ID: return {
      ...state,
      singlePartnerDetail: {}
    }

    case FETCH_PARTNER_DASHBOARD_DETAILS_SUCCESS: return {
      ...state,
      partnersDashboardDetails: action.payload,
      isLoading:false
    }

    case CREATE_PARTNER: return {
      ...state,
      dialogSaving: true
    }

    case CREATE_PARTNER_SUCCESS: {
      return {
        ...state,
        // makingRequest: false,
        fetchingDataGeneral: true,
        dialogSaving: false,
        dialogSaveSuccess: true,
      }
    }

    case CREATE_PARTNER_FAILURE: {
      return {
        ...state,
        dialogSaving: false,
        dialogSaveSuccess: false,
      }
    }

    case EDIT_PARTNER: return {
      ...state,
      dialogSaving: true,
    }

    case EDIT_PARTNER_SUCCESS: return {
      ...state,
      // makingRequest: false,
      fetchingDataGeneral: true,

      dialogSaving: false,
      dialogSaveSuccess: true,
    }

    case EDIT_PARTNER_FAILURE: return {
      ...state,
      dialogSaving: false,
      dialogSaveSuccess: false,
    }

    case RESET_ACTION_DIALOG: return {
      ...state,
      dialogSaving: false,
      dialogSaveSuccess: false,     
    }

    case ACTIVATE_PARTNER_SUCCESS: return {
      ...state,
      makingRequest: false,
      fetchingDataGeneral: true,
    }

    case DEACTIVATE_PARTNER_SUCCESS: return {
      ...state,
      makingRequest: false,
      fetchingDataGeneral: true,
    }

    case EXPORT_PARTNER_SUCCESS: return {
      ...state,
      makingRequest: false,
    }

    case RESTORE_PARTNERS_INITIAL: return {
      ...state,
    }

    case MAKE_REQUEST_PARTNERS: return {
      ...state,
      makingRequest: true,
    }

    case FETCH_DIALOG_DATA: return {
      ...state,
      fetchingPartnerDialogData: true,
    }

    case PRINT_PARTNERS_SUCCESS: return {
      ...state,
      allPartnersDataForPrinting: action.payload,
    }

    case SEARCH_TABLE: return {
      ...state,
      fetchingDataGeneral: true,
    }

    default: return state;
  }
}

export default reducers;